import React from 'react'
import styled from 'styled-components'

/**
 * 選択肢の各行
 */
const ItemLine: React.FC<ItemLineProps> = (props) => {
  const {
    isInvalid,
    showLineBorder,
    isHide,
    lineOffset,
    width,
    variableHeight,
    paddingUnnecessary,
    children,
    onClick,
    setShowAlert,
  } = props
  // isInvalidは入力変更中、常に変化する
  // フォーカス時の状態を保持
  const [memoIsInvalid, setMemoIsInvalid] = React.useState(isInvalid ?? false)
  // エラーから正常値になったことを保持（入力中）
  const [beCollectFlg, setBeCollectFlg] = React.useState(false)
  // バリデーションのハイライト管理ステート
  const [isHighlight, setIsHighlight] = React.useState(isInvalid ?? false)

  // onblurステートを固定
  const handleOnblur = (): void => {
    if (isInvalid === undefined || !setShowAlert) return
    // 現在の入力値のバリデーション状況を保持
    setMemoIsInvalid(isInvalid)
    setIsHighlight(isInvalid)
    setShowAlert(isInvalid)
    // エラーから正常値になることを検知するためfalseで初期化
    setBeCollectFlg(false)
  }
  React.useEffect(() => {
    if (isInvalid === undefined || !setShowAlert) return
    if (!beCollectFlg && memoIsInvalid) {
      if (!isInvalid) {
        setBeCollectFlg(true)
      }
      setIsHighlight(isInvalid)
      setShowAlert(isInvalid)
    }
  }, [isInvalid])
  return (
    <React.Fragment>
      {!isHide && (
        <StyledItemLine
          showLineBorder={showLineBorder}
          lineOffset={lineOffset}
          width={width}
          onBlur={handleOnblur}
          backgroundColor={isHighlight}
        >
          <ItemLineContent
            onClick={isHide ? undefined : onClick}
            variableHeight={variableHeight}
            paddingUnnecessary={paddingUnnecessary}
          >
            {children}
          </ItemLineContent>
        </StyledItemLine>
      )}
    </React.Fragment>
  )
}

export type ItemLineProps = {
  children: React.ReactNode
  showLineBorder?: boolean
  lineOffset?: string
  variableHeight?: boolean
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  setShowAlert?: (isInvalid: boolean) => void
  isHide?: boolean
  width?: string
  paddingUnnecessary?: boolean
  isInvalid?: boolean
  input?: string
}

export const StyledItemLine = styled.div<{
  showLineBorder?: boolean
  lineOffset?: string
  width?: string
  backgroundColor: boolean
}>`
  ${(props): string =>
    props.width
      ? `
      width:${props.width};
      background: ${
        props.backgroundColor
          ? 'var(--color-invalid-background)'
          : 'var(--color-content-background)'
      };
      border-top: 1px solid var(--color-border);
      border-bottom: 1px solid var(--color-border);
      `
      : ''}

  ${(props): string =>
    props.showLineBorder
      ? `
      &&:after {
        position: relative;
        left: ${props.lineOffset ? props.lineOffset : '0'};
        display: block;
        width: calc(100% - ${props.lineOffset ? props.lineOffset : '0'});
        border-bottom: 1px solid var(--color-border);
        content: '';
      }
      &&:last-child:after {
        border-bottom: none;
      }
      `
      : ''}
`

const ItemLineContent = styled.div<{
  variableHeight?: boolean
  paddingUnnecessary?: boolean
}>`
  display: flex;
  align-items: center;
  ${(props): string => (props.paddingUnnecessary ? '' : 'padding-block: 8px;')}
  ${(props): string => (props.variableHeight ? '' : 'height: auto;')}
`

export default ItemLine
